@if (university(); as university) {
	@if (!isLoading() && course(); as course) {
		<uc-university-header
			*ucRemoveDuplicateDomElement="'hideOnMobile'"
			[logo]="university.logo"
			[uniName]="university.name"
			[saved]="course.saved"
			[id]="course.id"
			[delta]="2"
			[ugSearchOrderPosition]="university.order"
			[cleSearchOrderPosition]="null"
			[courseSlug]="course.slug"
			[academicYear]="course.academic_year"
			[product]="studyLevel()"
		>
			<uc-header-title
				headerTitle
				[courseName]="course.name"
				[uniName]="university.name"
				[uniSlug]="uniSlug()"
				[product]="studyLevel()"
				[uniId]="university.id"
				[searchOrderPosition]="university.order"
			/>
		</uc-university-header>
		@if (uniGallery(); as uniGallery) {
			<uc-university-slider
				[uniGallery]="uniGallery"
				[product]="studyLevel()"
				[isFeaturedGallery]="isFeaturedGallery()"
				[uniSliderCopy]="uniSliderCopy()"
				[id]="course.id"
				[saved]="course.saved"
				[delta]="2"
				[courseSlug]="course.slug"
				[uniName]="university.name"
				[ugSearchOrderPosition]="university.order"
				[cleSearchOrderPosition]="null"
				[academicYear]="course.academic_year"
			>
				<uc-header-title
					headerTitle
					[courseName]="course.name"
					[uniName]="university.name"
					[uniSlug]="uniSlug()"
					[product]="studyLevel()"
					[uniId]="university.id"
					[searchOrderPosition]="university.order"
				/>
				<uc-cta-non-clearing
					[isFeatured]="isFeatured()"
					[uniId]="university.id"
					[externalUrl]="externalUrl()"
					[externalEventsUrl]="externalEventsUrl()"
					[externalProspectusUrl]="externalProspectusUrl()"
					[product]="studyLevel()"
					[uniSlug]="university.slug"
					[uniName]="university.name"
					sourceType="course"
					[privacyPolicyUrl]="university.privacy_policy_url"
					[courseName]="course.name"
					[ugSearchOrderPosition]="university.order"
				/>
			</uc-university-slider>
		}
		<div class="container">
			<!-- Course Overview -->
			@if (course.overview) {
				<div class="divider">
					<div class="mb-5 sm:mb-4">
						<uc-heading
							headingTitle="Course Overview - {{ course.name }}"
							[description]="course.overview"
						/>
					</div>
					<!-- CTA for premium profiles (not clearing) -->
					@if (isFeatured() && course) {
						<uc-visit-website-btn
							[externalUrl]="externalUrl()"
							[product]="studyLevel()"
							componentName="Course Overview"
							customStyles="w-full sm:w-80"
							[uniId]="university.id"
							sourceType="course"
							[source]="course.name"
							[ugSearchOrderPosition]="university.order"
							[uniName]="university.name"
							data-cy="course-overview-visit-website-btn"
						/>
					}
				</div>
			}
		</div>
		<!-- Course Information -->
		@if (course?.options && course.options[selectedIndex()]; as selectedOption) {
			<uc-course-information
				[isFeatured]="isFeatured()"
				class="md:col-span-2"
				[courseOptions]="course.options"
				[selectedIndex]="selectedIndex()"
				[clearingCourseEnabled]="clearingCourseEnabled"
				(selectIndex)="onCourseOptionSelect($event)"
			>
				@if (isFeatured()) {
					<div class="grid grid-cols-2 gap-3 mt-6 sm:gap-3">
						<uc-request-btn
							[params]="university.id"
							componentName="Course Information"
							customStyles="w-full sm:w-full"
							[product]="studyLevel()"
							[courseName]="course.name"
							[ugSearchOrderPosition]="university.order"
							data-cy="course-information-request-btn"
						/>

						<uc-visit-website-btn
							[externalUrl]="externalUrl()"
							[product]="studyLevel()"
							componentName="Course Information"
							[uniId]="university.id"
							buttonText="Learn More"
							customStyles="w-full"
							[uniId]="university.id"
							sourceType="course"
							[source]="course.name"
							[ugSearchOrderPosition]="university.order"
							[uniName]="university.name"
							data-cy="course-information-visit-website-btn"
						/>
					</div>
				}
			</uc-course-information>
			<!-- Application Details -->
			<uc-course-profile-application-details
				[isFeatured]="isFeatured()"
				[externalUrl]="externalUrl()"
				[courseCode]="course.code"
				[institutionCode]="course.institution_code"
				[entryPoints]="selectedOption.entry_years"
				[applicationDeadline]="selectedOption.application_deadline"
				[uniId]="university.id"
				[product]="studyLevel()"
				[clearingCourseEnabled]="clearingCourseEnabled"
				[currentClearingYear]="currentClearingYear"
				[courseName]="course.name"
				[searchOrder]="university.order"
				[uniName]="university.name"
				[privacyPolicyUrl]="university.privacy_policy_url"
			/>
			<!-- Entry requirements -->
			@if (hasEntryRequirements(selectedOption)) {
				<uc-entry-requirements
					[externalUrl]="externalUrl()"
					[entryRequirements]="selectedOption.entry_requirements!"
					[isFeatured]="isFeatured()"
				>
					<ng-template #visitWebsiteBtn>
						<uc-visit-website-btn
							[externalUrl]="externalUrl()"
							[externalUrl]="externalUrl()"
							customStyles="w-full sm:w-auto"
							[product]="studyLevel()"
							componentName="Entry Requirements"
							[uniId]="university.id"
							[uniName]="university.name"
							buttonText="Find Out More"
							sourceType="course"
							[source]="course.name"
							[ugSearchOrderPosition]="university.order"
						/>
					</ng-template>
				</uc-entry-requirements>
			}
			<uc-course-search-banner
				[product]="studyLevel()"
				[uniName]="university.name"
				[uniSlug]="university.slug"
				[description]="description()"
			/>
			<!-- Upcoming Events -->
			@if (isFeatured() && events()) {
				<uc-university-events
					[paidFeatures]="university.paid_features"
					[rating]="university.stats.rating"
					[events]="events()"
					[product]="studyLevel()"
					[uniName]="university.name"
					[uniSlug]="university.slug"
					[uniLogo]="university.logo"
					[uniId]="university.id"
					componentName="Event Ticket"
					[externalEventsUrl]="externalEventsUrl()"
					[ugSearchOrderPosition]="university.order"
					[privacyPolicyUrl]="university.privacy_policy_url"
				/>
			}
			<!-- Request Information CTA -->
			@if (isFeatured() && !clearingCourseEnabled) {
				<div class="container">
					<uc-engage-card-cta
						backgroundImageClass="bg-cta-request-info"
						cardTitle="Request Information"
						icon="request_info_cta_icon.svg"
						borderColor="sm:border-uc-green-700"
						headingColor="text-uc-green-700"
						description="Any questions about a specific university or course? Request some information and find out everything you need to know."
						iconText="Request More Information"
						link="/request"
						[qParams]="{
							uni: university.id!,
							product: abbreviatedProduct(),
						}"
						(ctaClicked)="onRequestInfoClick(university.order, course.name)"
						[ugSearchOrderPosition]="university.order"
						[cleSearchOrderPosition]="null"
					>
						<uc-request-btn
							[params]="university.id"
							componentName="Request Information CTA"
							customStyles="w-full"
							[product]="studyLevel()"
							[courseName]="course.name"
							[ugSearchOrderPosition]="university.order"
							data-cy="course-details-request-info-cta-btn"
						/>
					</uc-engage-card-cta>
				</div>
			}
			<!-- Fees an Funding -->
			@if (hasFees(selectedOption)) {
				<uc-fees-and-funding
					[fees]="selectedOption.fees!"
					[externalUrl]="
						course.external_scholarships_url ?? selectedOption.external_url
					"
					[isFeatured]="isFeatured()"
				>
					<!-- desktop -->
					<ng-template #visitWebsiteBtnFeesFunding>
						<uc-visit-website-btn
							[externalUrl]="externalUrl()"
							[externalUrl]="externalUrl()"
							customStyles="w-full sm:w-auto"
							[product]="studyLevel()"
							componentName="Fees and Funding"
							[uniId]="university.id"
							buttonText="Find Out More"
							sourceType="course"
							[source]="course.name"
							[ugSearchOrderPosition]="university.order"
							[uniName]="university.name"
							data-cy="fees-funding-visit-website-btn"
						/>
					</ng-template>
				</uc-fees-and-funding>
			}
			<!-- If no data for fees and funding -->
			@if (!hasFees(selectedOption)) {
				<uc-no-fees-and-funding [courseName]="course.name">
					<uc-visit-website-btn
						customStyles="!font-bold !text-gray-800 !underline !border-0 !bg-transparent !p-0"
						[externalUrl]="externalUrl()"
						componentName="Fees and Funding"
						[uniId]="university.id"
						[source]="course.name"
						sourceType="course"
						[uniName]="university.name"
						[ugSearchOrderPosition]="university.order"
						[product]="studyLevel()"
						buttonText="Click here"
						data-cy="no-fees-funding-visit-website-btn"
					/>
				</uc-no-fees-and-funding>
			}
			<!-- Get Prospectus CTA -->
			@if (isFeatured()) {
				<div class="container">
					<uc-engage-card-prospectus-cta
						mainTitle="Get Prospectus"
						subTitle="Order Free Prospectuses"
						description="The ideal way to read about detailed course information is with a university prospectus. Request a FREE prospectus and learn more about this course today."
						[externalProspectusUrl]="externalProspectusUrl()"
						[privacyPolicyUrl]="university.privacy_policy_url"
						[product]="studyLevel()"
						[uniId]="university.id"
						[ugSearchOrderPosition]="university.order"
					/>
				</div>
			}

			<!-- On desktop -> show university buttons at the bottom-->
			@if (isFeatured()) {
				<uc-client-profile-sticky-lead-bar-desktop
					[uniId]="university.id"
					[product]="studyLevel()"
					[paidFeatures]="university.paid_features"
					[externalUrl]="course.external_url"
					[prospectusExternalUrl]="externalProspectusUrl()"
					[externalEventsUrl]="externalProspectusUrl()"
					[showClearing]="false"
					[source]="course.name"
					sourceType="course"
					[privacyPolicyUrl]="university.privacy_policy_url"
					[ugSearchOrderPosition]="university.order"
					[cleSearchOrderPosition]="null"
					[uniName]="university.name"
				/>
				<uc-client-profile-sticky-lead-bar-mobile [isFeatured]="isFeatured()">
					<uc-visit-website-btn
						customStyles="w-full"
						[externalUrl]="course.external_url"
						componentName="Sticky Lead Bar"
						[uniId]="university.id"
						[source]="course.name"
						sourceType="course"
						[uniName]="university.name"
						[ugSearchOrderPosition]="university.order"
						[product]="studyLevel()"
					/>
				</uc-client-profile-sticky-lead-bar-mobile>
			}
		}
		@if (!isFeatured()) {
			<uc-recommended-unis-carousel />
		}
	}
}
@if (isLoading()) {
	<uc-course-skeleton />
}
